// extracted by mini-css-extract-plugin
export default {"title":"Accordion_title__tD2pZ","dark":"Accordion_dark__cLJUr","titleText":"Accordion_titleText__8twJJ","expand":"Accordion_expand__O2P+V","content":"Accordion_content__5LU2x"};